/**
 * GÖMÜLÜ İKİLİ GÖVDELER — `email-mask-decoders.ts`in 2a/2d bölümü, AYRI DOSYA.
 *
 * base64 · base64url · onaltılık · base32 · RFC 2047 · UTF-7 AYNI ŞEYİN altı
 * yazımıdır: adresin baytları bir tabana çevrilip metne gömülür ve karakter
 * kaçışı çözücüleri onları HİÇ görmez. Dördüncü dalgada (16.09.2026) dördü de
 * ham geçti; ikisi GERÇEK sağlayıcı biçimidir:
 *   · `=?utf-8?B?YWxpQG9ybmVrLmNvbQ==?=` — RFC 2047 encoded-word. Sağlayıcı
 *     başlıklarında (Subject, To, Diagnostic-Code) günlük olarak geçer.
 *   · `dG89YWxpQG9ybmVrLmNvbQ==` — düz base64 gövde (API yanıtı, JWT parçası).
 * Base64 "şifreleme" değildir: personelin ekranında duran dizge adresin
 * KENDİSİDİR, yalnız bir satır uzaklıktadır.
 *
 * NEDEN AYRI DOSYA (yedinci dalga, 16.09.2026): `email-mask-decoders.ts` 445
 * satırdı ve tavan 500. Bu turda adlı varlık kuralı ile sarmalanmış `@` kuralı
 * oraya giriyor; bayt çözme makinesi kavramsal olarak zaten ayrı bir iştir
 * ("metin hangi TABANDA yazılmış" ≠ "hangi KARAKTER kaçırılmış"). Kamuya açık
 * yüzey `email-mask-decoders.ts`ten yeniden dışa verilir; çağıranlar ve spec
 * eski yolu import etmeyi sürdürür.
 */
import { adresVarMi } from './email-mask-structure';
const B64_ALFABE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
/** base64 · base64url (`-_`) · UTF-7'nin değiştirilmiş alfabesi (`,`) tek tabloda. */
function b64Deger(harf) {
    const dogrudan = B64_ALFABE.indexOf(harf);
    if (dogrudan >= 0)
        return dogrudan;
    if (harf === '-')
        return 62;
    if (harf === '_' || harf === ',')
        return 63;
    return -1;
}
export function b64Bayt(govde) {
    const baytlar = [];
    let tampon = 0;
    let bit = 0;
    for (const harf of govde) {
        if (harf === '=')
            break;
        const deger = b64Deger(harf);
        if (deger < 0)
            return null;
        tampon = (tampon << 6) | deger;
        bit += 6;
        if (bit >= 8) {
            bit -= 8;
            baytlar.push((tampon >> bit) & 0xff);
        }
    }
    return baytlar;
}
/**
 * Bayt dizisi → metin. GEÇERSİZ ya da BASILAMAZ çıktı `null` döner: çözüm
 * yalnız "gerçekten metin" olduğunda kabul edilir, çöp metne yazılmaz.
 */
export function utf8Metin(baytlar) {
    let sonuc = '';
    for (let index = 0; index < baytlar.length; index += 1) {
        const bayt = baytlar[index];
        let kod;
        let ek;
        if (bayt < 0x80) {
            kod = bayt;
            ek = 0;
        }
        else if (bayt >= 0xc2 && bayt <= 0xdf) {
            kod = bayt & 0x1f;
            ek = 1;
        }
        else if (bayt >= 0xe0 && bayt <= 0xef) {
            kod = bayt & 0x0f;
            ek = 2;
        }
        else if (bayt >= 0xf0 && bayt <= 0xf4) {
            kod = bayt & 0x07;
            ek = 3;
        }
        else {
            return null;
        }
        for (let adim = 0; adim < ek; adim += 1) {
            const sonraki = baytlar[index + 1 + adim];
            if (sonraki === undefined || (sonraki & 0xc0) !== 0x80)
                return null;
            kod = (kod << 6) | (sonraki & 0x3f);
        }
        index += ek;
        if (kod > 0x10ffff || (kod >= 0xd800 && kod <= 0xdfff))
            return null;
        // Basılamaz kontrol karakteri → bu gövde metin değildir.
        if (kod < 0x20 && kod !== 0x09 && kod !== 0x0a && kod !== 0x0d)
            return null;
        sonuc += String.fromCodePoint(kod);
    }
    return sonuc;
}
/** UTF-7 kaydırma dizisi UTF-16BE taşır (`AEA` → `@` → `@`). */
export function utf16beMetin(baytlar) {
    if (baytlar.length < 2)
        return null;
    let sonuc = '';
    for (let index = 0; index + 1 < baytlar.length; index += 2) {
        const kod = (baytlar[index] << 8) | baytlar[index + 1];
        if (kod < 0x20 || (kod >= 0xd800 && kod <= 0xdfff))
            return null;
        sonuc += String.fromCharCode(kod);
    }
    return sonuc;
}
/* --- 2d. DÖRT TABAN, TEK AİLE --------------------------------------------
 *
 * QA'nın beşinci dalgasında dördü de ölçüldü ve üçü ham geçti. Aile olarak
 * yazılırlar; yeni bir taban (base58 …) eklemek TEK SATIRDIR ve `IKILI_GOVDELER`
 * kapıda ENUMERE edilir — taban silinirse test KIRILIR.
 *
 * TABAN YOK, YALNIZ ALFABENİN GEREKTİRDİĞİ ASGARİ UZUNLUK VAR: 3 bayt (`a@b`)
 * base64'te 4, onaltılıkta 6, base32'de 5 karakter eder. Tavan da yoktur.
 */
const B32_ALFABE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
function b32Bayt(govde) {
    const baytlar = [];
    let tampon = 0;
    let bit = 0;
    for (const harf of govde) {
        if (harf === '=')
            break;
        const deger = B32_ALFABE.indexOf(harf);
        if (deger < 0)
            return null;
        tampon = (tampon << 5) | deger;
        bit += 5;
        if (bit >= 8) {
            bit -= 8;
            baytlar.push((tampon >> bit) & 0xff);
        }
    }
    return baytlar;
}
function hexBayt(govde) {
    if (govde.length % 2 !== 0)
        return null;
    const baytlar = [];
    for (let index = 0; index < govde.length; index += 2) {
        baytlar.push(Number.parseInt(govde.slice(index, index + 2), 16));
    }
    return baytlar;
}
export const IKILI_GOVDELER = [
    {
        ad: 'base64',
        desen: /[A-Za-z0-9+/_-]{4,}={0,2}/g,
        bayt: b64Bayt,
        ornek: 'payload YWxpQHguY28= rejected',
    },
    {
        ad: 'base64url',
        desen: /[A-Za-z0-9_-]{4,}/g,
        bayt: b64Bayt,
        ornek: 'payload YWxpQHguY28 rejected',
    },
    {
        ad: 'onaltilik',
        desen: /(?:[0-9A-Fa-f]{2}){3,}/g,
        bayt: hexBayt,
        ornek: 'payload 616c6940782e636f rejected',
    },
    {
        ad: 'base32',
        desen: /[A-Z2-7]{5,}={0,6}/g,
        bayt: b32Bayt,
        ornek: 'payload MFWGSQDYFZRW6=== rejected',
    },
];
/**
 * Gömülü ikili gövdeleri çözer. `govdeler` alt kümesi YALNIZ kapı içindir:
 * her taban TEK BAŞINA sürülür ve kendi örneğini GERÇEKTEN çözdüğü ölçülür.
 *
 * NEDEN TEK BAŞINA (kapı saldırısı bulgusu, 16.09.2026): base64 tabanını eski
 * fail-open hâline (`{12,}`) geri çeviren saldırı kapıdan GEÇTİ, çünkü
 * base64url girdisi aynı gövdeyi dolgusuz hâliyle yakalayıp sızıntıyı
 * ÖRTÜYORDU. Telafi eden kapı kör kapıdır; ayak bu yüzden tabanları yalıtır.
 *
 * FAIL-CLOSED AMA GÜRÜLTÜSÜZ: gövde yalnız ÇÖZÜMÜ GERÇEKTEN ADRES BİÇİMİNDEYSE
 * yerine konur. İkinci bir adres tanımı YOKTUR — tanım `email-mask-structure.ts`
 * tekindedir (`ali @ ornek.com` taşıyan bir gövde mini desende "adres değil"
 * sayılıp ham bırakılıyordu).
 */
export function ikiliGovdeleriCoz(metin, govdeler = IKILI_GOVDELER) {
    return govdeler.reduce((sonuc, govde) => {
        govde.desen.lastIndex = 0;
        return sonuc.replace(govde.desen, (tam) => {
            const baytlar = govde.bayt(tam);
            const cozum = baytlar ? utf8Metin(baytlar) : null;
            return cozum !== null && adresVarMi(cozum) ? cozum : tam;
        });
    }, metin);
}
//# sourceMappingURL=email-mask-binary.js.map